export default __webpack_public_path__ + "static/media/p23.5dbcd447.jpg";